import { AfterViewChecked, ChangeDetectorRef, Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { SpinnerComponent } from "./components/spinner/spinner.component";
import { LoadingService } from './services/loading.service';
import { CommonModule } from '@angular/common';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { getPaginatorIntl } from './shared/i18n/mat-paginator-intl-pt';
import { ThemeService } from './services/theme.service';
import { IThemeTypes } from './interfaces/themes.interface';
import { HomologationBatchExportProgressComponent } from './components/homologation-batch-export-progress/homologation-batch-export-progress.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,
    SpinnerComponent,
    CommonModule,
    HomologationBatchExportProgressComponent,
  ],
  providers: [
    { provide: MatPaginatorIntl, useFactory: getPaginatorIntl },
  ],
  template: `
    <router-outlet />
    <app-spinner *ngIf="loading$ | async"  />
    <app-homologation-batch-export-progress />
  `,
})
export class AppComponent implements AfterViewChecked {
  private loadingService = inject(LoadingService);
  private cdRef = inject(ChangeDetectorRef);
  loading$ = this.loadingService.loading$;
  private themeService = inject(ThemeService);

  ngAfterViewChecked(): void {
    this.cdRef.detectChanges();
    const systemType = sessionStorage.getItem('systemType') as IThemeTypes;
    this.themeService.setTheme(systemType);
  }
}
